import { DialogProps } from '@material-ui/core';
import React, { useContext } from 'react';
import { ImageScannerApplicationContext } from 'app/externalApps/imageScanner/ImageScannerApplicationContext';
import { DownloadAndInstallSoftwareDialog } from './DownloadAndInstallSoftwareDialog';

interface IProps extends DialogProps {
	close: VoidFunction;
}

export const DownloadAndInstallScanSoftwareDialog = ({ ...rest }: IProps) => {
	const { download, isDownloading } = useContext(ImageScannerApplicationContext);

	return (
		<DownloadAndInstallSoftwareDialog
			{...rest}
			download={download}
			isDownloading={isDownloading}
			title={`Download en installeer scan software`}
		/>
	);
};
